export const colors = {
  blue_050: '#DCEEFB',
  blue_100: '#B6E0FE',
  blue_200: '#84C5F4',
  blue_300: '#62B0E8',
  blue_400: '#4098D7',
  blue_500: '#2680C2',
  blue_600: '#186FAF',
  blue_700: '#0F609B',
  blue_800: '#0A558C',
  blue_900: '#003E6B',

  yellow_vivid_050: '#FFFBEA',
  yellow_vivid_100: '#FFF3C4',
  yellow_vivid_200: '#FCE588',
  yellow_vivid_300: '#FADB5F',
  yellow_vivid_400: '#F7C948',
  yellow_vivid_500: '#F0B429',
  yellow_vivid_600: '#DE911D',
  yellow_vivid_700: '#CB6E17',
  yellow_vivid_800: '#B44D12',
  yellow_vivid_900: '#8D2B0B',

  blue_grey_050: '#F0F4F8',
  blue_grey_100: '#D9E2EC',
  blue_grey_200: '#BCCCDC',
  blue_grey_300: '#9FB3C8',
  blue_grey_400: '#829AB1',
  blue_grey_500: '#627D98',
  blue_grey_600: '#486581',
  blue_grey_700: '#334E68',
  blue_grey_800: '#243B53',
  blue_grey_900: '#102A43',

  cyan_050: '#E0FCFF',
  cyan_100: '#BEF8FD',
  cyan_200: '#87EAF2',
  cyan_300: '#54D1DB',
  cyan_400: '#38BEC9',
  cyan_500: '#2CB1BC',
  cyan_600: '#14919B',
  cyan_700: '#0E7C86',
  cyan_800: '#0A6C74',
  cyan_900: '#044E54',

  red_050: '#FFEEEE',
  red_100: '#FACDCD',
  red_200: '#F29B9B',
  red_300: '#E66A6A',
  red_400: '#D64545',
  red_500: '#BA2525',
  red_600: '#A61B1B',
  red_700: '#911111',
  red_800: '#780A0A',
  red_900: '#610404',
};
